"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/empty/style/css");

var _empty = _interopRequireDefault(require("antd/es/empty"));

var _card = _interopRequireDefault(require("antd/lib/card"));

var _descriptions = _interopRequireDefault(require("antd/lib/descriptions"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _ProgressStatCard = _interopRequireDefault(require("../../../components/statistics/ProgressStatCard"));

var _Util = require("../../../components/util/Util");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _study = require("../../../redux/study/study.types");

require("./study.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Study extends _react.Component {
  componentDidMount() {
    const {
      study,
      loadStudyStats
    } = this.props;

    if (study) {
      loadStudyStats(study.id);
    }
  }

  render() {
    const {
      study,
      studyArms,
      studyStats
    } = this.props;

    if (!study) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error Loading Study");
    }

    const arms = study.studyArms;
    const studyStatsProp = studyStats || [];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "study-page"
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      title: study.name
    }, /*#__PURE__*/_react.default.createElement(_descriptions.default, null, /*#__PURE__*/_react.default.createElement(_descriptions.default.Item, {
      label: "Start Date"
    }, study.startDate ? (0, _moment.default)(study.startDate).format('MM/DD/YYYY') : 'Unknown')), /*#__PURE__*/_react.default.createElement(_descriptions.default, null, /*#__PURE__*/_react.default.createElement(_descriptions.default.Item, {
      label: "Description"
    }, study === null || study === void 0 ? void 0 : study.description))), /*#__PURE__*/_react.default.createElement("div", {
      className: "progress-stat-card-container"
    }, (studyStatsProp === null || studyStatsProp === void 0 ? void 0 : studyStatsProp.length) ? studyStatsProp.map(study => {
      return /*#__PURE__*/_react.default.createElement(_ProgressStatCard.default, {
        key: study.studyArmId,
        title: "Active Participants",
        subTitle: (0, _Util.getStudyArmLabelFromId)(studyArms, study.studyArmId),
        count: study.activeParticipant,
        color: "blue",
        total: study.targetCount
      });
    }) : /*#__PURE__*/_react.default.createElement("div", {
      className: "empty-container"
    }, /*#__PURE__*/_react.default.createElement(_empty.default, {
      image: _empty.default.PRESENTED_IMAGE_SIMPLE,
      description: "No active participant or study arm data yet"
    }))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  study: selectors.getRequestedStudy,
  studyArms: selectors.getStudyArms,
  studyStats: selectors.getStudyStats
});

const mapDispatchToProps = dispatch => {
  return {
    loadStudyStats: studyId => dispatch(_study.loadStudyStatsAsync.request(studyId))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Study);

exports.default = _default;